module.exports = __webpack_public_path__ + "static/img/1_1_3.2c311964.jpg";